export { default as SportStrip, type Details } from './SportStrip';
export { default as DriverStrip } from './DriverStrip';
